export default __webpack_public_path__ + "static/media/PC-Crispy.2e49da16.png";